import * as tasks from './minigames/xml/kpp';

function transObjToArray(){
    let result = [];
    for(let task in tasks){
        result.push(tasks[task]);
    }
    return result;
}

export default transObjToArray();